type EnvironmentNames = 'PROD' | 'BETAPROD' | 'TIP' | 'SI' | 'BETASI' | 'CI';

export const Environment: Record<EnvironmentNames, EnvironmentNames> = {
  PROD: 'PROD',
  BETAPROD: 'BETAPROD',
  TIP: 'TIP',
  SI: 'SI',
  BETASI: 'BETASI',
  CI: 'CI',
};

const PROD_SEARCH_PARAM = 'isHardProd';

const ProdPattern: RegExp[] = [
  /^(ui\.)?bingads\.microsoft\.com$/, // Prod Bing Ads
  /^(ui\.)?(aks\d?\.|netcore\.)?ads\.microsoft\.com$/, // Prod Microsoft Ads
  /^about\.ads\.microsoft\.com$/, // Prod about page which is facing customers
];

const BetaProdPattern: RegExp[] = [
  /^(ui\.)?beta\.bingads\.microsoft\.com$/, // BetaProd Bing Ads
  /^(app1\.)?(ui\.)?(aks\d?\.|netcore\.)?beta\.ads\.microsoft\.com(:12000)?$/, // BetaProd Microsoft Ads
  /^preview-about\.ads\.microsoft\.com$/, // BETA PROD about page which is facing customers
  /^stage-(preview-)?about\.ads\.microsoft\.com$/, // BETA PROD about page which is facing staging
];

const TipPattern: RegExp[] = [
  /^(ui\.)?tip\.bingads\.microsoft\.com$/, // Tip Bing Ads
  /^(app1\.)?(ui\.)?(aks\d?\.|netcore\.)?tip\.?ads\.microsoft\.com(:12000)?$/, // Tip Microsoft Ads
];

const SIPattern: RegExp[] = [
  /^(ui\.)?si\.bingads\.microsoft\.com$/, // SI Bing Ads
  /^(app1\.)?(ui\.)?(aks\d?\.|netcore\.)?ads-int\.microsoft\.com(:12000)?$/, // SI Microsoft Ads
  /^qa-(preview-)?about\.ads\.microsoft\.com$/, // SI about page which is facing qa
  /^dev-(preview-)?about\.ads\.microsoft\.com$/, // SI about page which is facing dev
  /^testuiresources\.z5\.web\.core\.windows\.net$/, // SI hosted copilot bundle
];

const BetaSIPattern: RegExp[] = [
  /(ui\.)?beta\.si\.bingads\.microsoft\.com$/, // Beta SI Bing Ads
  /^(ui\.)?(aks\d?\.|netcore\.)?beta\.ads-int\.microsoft\.com$/, // Beta SI Microsoft Ads
];

export function getEnvironment(domain: string, search?: string) {
  if (search) {
    const params = new URLSearchParams(search);
    if (params.get(PROD_SEARCH_PARAM) === '1' || params.get(PROD_SEARCH_PARAM) === 'true') {
      return Environment.PROD;
    }
  }

  if (ProdPattern.some((pattern) => domain.match(pattern))) {
    return Environment.PROD;
  }

  if (BetaProdPattern.some((pattern) => domain.match(pattern))) {
    return Environment.BETAPROD;
  }

  if (TipPattern.some((pattern) => domain.match(pattern))) {
    return Environment.TIP;
  }

  if (SIPattern.some((pattern) => domain.match(pattern))) {
    return Environment.SI;
  }

  if (BetaSIPattern.some((pattern) => domain.match(pattern))) {
    return Environment.BETASI;
  }

  return Environment.CI;
}

export const isProdEnv = (domain = window.location.host, search = window.location.search) => {
  const env = getEnvironment(domain, search);
  return env === Environment.PROD || env === Environment.BETAPROD || env === Environment.TIP;
};

export const useIsProdEnvironment = (domain = window.location.host) => isProdEnv(domain);
